
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles } from "lucide-react";
import { useAIAnalysis } from "@/hooks/useAIAnalysis";

interface AIAnalysisToolsProps {
  message: string;
  isAnalyzing: boolean;
  setIsAnalyzing: (isAnalyzing: boolean) => void;
  onAnalysisComplete: (data: { formattedText: string; voNumber: string | null }) => void;
}

const AIAnalysisTools = ({ 
  message, 
  isAnalyzing, 
  setIsAnalyzing, 
  onAnalysisComplete 
}: AIAnalysisToolsProps) => {
  const { analyzeText } = useAIAnalysis(onAnalysisComplete);

  const handleAIAnalysis = () => {
    analyzeText(message);
  };

  return (
    <Button 
      type="button" 
      variant="default" 
      size="sm" 
      onClick={handleAIAnalysis}
      className="flex items-center gap-1 bg-blue-500 hover:bg-blue-600"
      disabled={isAnalyzing}
    >
      {isAnalyzing ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Sparkles className="h-4 w-4" />
      )}
      AI pakbon
    </Button>
  );
};

export default AIAnalysisTools;
